import React, { useEffect, useRef } from 'react';
import { List, Avatar } from 'antd';
import styled from 'styled-components';

const DropdownContainer = styled.div`
  position: absolute;
  left: 10px;
  right: 10px;
  bottom: 100%;
  margin-bottom: 8px;
  background: white;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
`;

const ListItem = styled(List.Item)`
  cursor: pointer;
  padding: 8px 12px;
  
  &:hover {
    background-color: #f5f5f5;
  }
  
  &.selected {
    background-color: rgb(249, 249, 249);
  }
`;

export const MentionDropdown = ({
  users,
  searchTerm,
  selectedIndex,
  onSelect,
  visible
}) => {
  const listRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    if (visible && selectedIndex >= 0) {
      // Get the actual DOM element - try listRef first, then containerRef
      if (listRef.current) {
        const listElement = listRef.current?.$el
        const listItems = listElement?.querySelectorAll('.ant-list-item');
        if (listItems?.[selectedIndex]) {
          listItems[selectedIndex].scrollIntoView({
            block: 'nearest',
            behavior: 'smooth'
          });
        }
      }
    }
  }, [selectedIndex, visible]);

  if (!visible || !users.length) {
    return null;
  }

  const filteredUsers = users.filter(user => {
    if (!searchTerm) return true;
    const search = searchTerm.toLowerCase();
    const fullName = `${user.firstName || ''} ${user.lastName || ''}`.toLowerCase();
    const email = (user.email || '').toLowerCase();
    return fullName.includes(search) || email.includes(search);
  });

  if (!filteredUsers.length) {
    return null;
  }

  const getInitials = (user) => {
    const first = (user.firstName || '').charAt(0).toUpperCase();
    const last = (user.lastName || '').charAt(0).toUpperCase();
    return first + last || '?';
  };

  const getUserDisplayName = (user) => {
    const name = `${user.firstName || ''} ${user.lastName || ''}`.trim();
    return name || user.email || 'Unknown User';
  };

  return (
    <DropdownContainer ref={containerRef}>
      <List
        ref={listRef}
        size="small"
        dataSource={filteredUsers}
        renderItem={(user, index) => (
          <ListItem
            className={index === selectedIndex ? 'selected' : ''}
            onClick={() => onSelect(user)}
          >
            <List.Item.Meta
              avatar={
                <Avatar size="small">
                  {getInitials(user)}
                </Avatar>
              }
              title={getUserDisplayName(user)}
              description={user.email}
            />
          </ListItem>
        )}
      />
    </DropdownContainer>
  );
};

